export enum PaymentStatus {
  Pending = "pending",
  PendingUnsubscribed = "pending_unsubscribed",
  PendingManual = "pending_manual",
  Paid = "paid",
  Failed = "failed",
  Canceled = "canceled",
  Unsubscribed = "unsubscribed",
  Overdue = "overdue",
  Issued = 'issued',

}

export const PendingPaymentStatuses = [
  PaymentStatus.Pending,
  PaymentStatus.PendingManual,
  PaymentStatus.PendingUnsubscribed,
];

export const PaymentStatusText: Record<PaymentStatus, string> = {
  paid: "결제 완료",
  pending: "결제 예정",
  pending_unsubscribed: "구독 해지 예정",
  failed: "결제 실패",
  canceled: "결제 취소",
  unsubscribed: "구독 해지 완료",
  pending_manual: "수기 결제",
  overdue: "연체",
  issued: "세금 계산서 발행"
};

export const AdditionalAgentFee = 30000;

export enum SubscriptionTier {
  Demo = "demo",
  Starter = "starter",
  Pro = "pro",
  Enterprise = "enterprise",
}

export const TierPrice: Record<SubscriptionTier, number> = {
  demo: 0,
  starter: 50000,
  pro: 90000,
  enterprise: 0,
};

export const Pricing: Record<
  SubscriptionTier,
  {
    baseFee: number;
    includedMessageQuota: number;
    extra_message_unit: number;
    extra_message_fee: number;
    extra_agent_fee: number;
  }
> = {
  [SubscriptionTier.Demo]: {
    baseFee: 0,
    includedMessageQuota: 0,
    extra_message_unit: 0,
    extra_message_fee: 0,
    extra_agent_fee: 0,
  },

  [SubscriptionTier.Starter]: {
    baseFee: 50000,
    includedMessageQuota: 1000,
    extra_message_unit: 300,
    extra_message_fee: 9000,
    extra_agent_fee: AdditionalAgentFee,
  },
  [SubscriptionTier.Pro]: {
    baseFee: 90000,
    includedMessageQuota: 1000,
    extra_message_unit: 300,
    extra_message_fee: 9000,
    extra_agent_fee: AdditionalAgentFee,
  },
  [SubscriptionTier.Enterprise]: {
    baseFee: 90000,
    includedMessageQuota: 1000,
    extra_message_unit: 300,
    extra_message_fee: 9000,
    extra_agent_fee: AdditionalAgentFee,
  },
};

// ItemSchedulingUpdate 과금 상수
export const ITEM_SCHEDULING_FREE_COUNT_PER_AGENT = 10;
export const ITEM_SCHEDULING_EXTRA_FEE = 300;

// 특화 에이전트 과금 상수
export const SPECIALIZED_AGENT_MONTHLY_FEE = 20_000;
export const PRO_FREE_SPECIALIZED_AGENT_PER_AGENT = 2;

// 메시지 과금 상수 (에이전트당)
export const MESSAGE_FREE_QUOTA_PER_AGENT = 1_000;
export const MESSAGE_EXTRA_UNIT = 300;
export const MESSAGE_EXTRA_FEE = 9_000;

export type DiscountType = "fixed" | "fixed_total" | "rate";
export type DiscountTarget = "fixed_fees" | "extra_costs" | "total";

export enum PriceAdjustmentReason {
  AGENT_ADDED = "AGENT_ADDED",
  AGENT_REMOVED = "AGENT_REMOVED",
  SPECIALIZED_AGENT_ADDED = "SPECIALIZED_AGENT_ADDED",
  SPECIALIZED_AGENT_REMOVED = "SPECIALIZED_AGENT_REMOVED",
  TIER_UPGRADED = "TIER_UPGRADED",
  DISCOUNT_APPLIED = "DISCOUNT_APPLIED",
  DISCOUNT_REMOVED = "DISCOUNT_REMOVED",
  CARRY_OVER_CREDIT_APPLIED = "CARRY_OVER_CREDIT_APPLIED",
  RECURRING_DISCOUNT_APPLIED = "RECURRING_DISCOUNT_APPLIED",
  RECURRING_DISCOUNT_REMOVED = "RECURRING_DISCOUNT_REMOVED",
}
